import axiosClient from "@/services/api/index";
import {
  OptionalUpgrade,
  CreateOptionalUpgradeInterface,
  QueryOptionalUpgradeInterface,
  UpdateOptionalUpgradeInterface,
  EstateOptionalUpgrade,
  CreateEstateOptionalUpgradeInterface,
  UpdateEstateOptionalUpgradeInterface,
} from "@/types/OptionalUpgradeInterface";

export default {
  async createOptionalUpgrade(
    params: CreateOptionalUpgradeInterface
  ): Promise<OptionalUpgrade> {
    return axiosClient
      .post("optional-upgrade", params)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async uploadImagesOptionalUpgrade(
    builderId: string,
    image: FormData
  ): Promise<unknown> {
    return axiosClient
      .post(`optional-upgrade/images/${builderId}`, image)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async uploadEstateOptionalUpgradeImage(
    estateId: string,
    image: FormData
  ): Promise<Array<{ Location: string; Key: string; format: string }>> {
    return axiosClient
      .post(`optional-upgrade/estate-images/${estateId}`, image)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async getAllOptionalUpgrades(): Promise<OptionalUpgrade[]> {
    return axiosClient
      .get("optional-upgrade")
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async getOptionalUpgradesByBuilderId(
    builderId: string
  ): Promise<OptionalUpgrade[]> {
    return axiosClient
      .get(`optional-upgrade/builder/${builderId}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async getOptionalUpgradeById(id: string): Promise<OptionalUpgrade> {
    return axiosClient
      .get(`optional-upgrade/${id}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async deleteOptionalUpgrade(id: string): Promise<void> {
    return axiosClient
      .delete(`optional-upgrade/${id}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async updateOptionalUpgrade(
    id: string,
    dto: UpdateOptionalUpgradeInterface
  ): Promise<void> {
    return axiosClient
      .patch(`optional-upgrade/${id}`, dto)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async createEstateOptionalUpgrade(
    params: CreateEstateOptionalUpgradeInterface
  ): Promise<EstateOptionalUpgrade> {
    return axiosClient
      .post("optional-upgrade/estate", params)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async getOptionalUpgradesByEstateId(
    estateId: string
  ): Promise<EstateOptionalUpgrade[]> {
    return axiosClient
      .get(`optional-upgrade/estate/${estateId}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async updateEstateOptionalUpgrade(
    id: string,
    dto: UpdateEstateOptionalUpgradeInterface
  ): Promise<void> {
    return axiosClient
      .patch(`optional-upgrade/${id}`, dto)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },

  async deleteEstateOptionalUpgrade(id: string): Promise<void> {
    return axiosClient
      .delete(`optional-upgrade/${id}`)
      .then((res) => res.data)
      .catch((err) => Promise.reject(err));
  },
};
